import {
  ClassAttributes,
  DependencyList,
  EffectCallback,
  forwardRef,
  Ref,
  RefAttributes,
  useEffect,
  useLayoutEffect,
  useRef,
} from 'react';

// eslint-disable-next-line @typescript-eslint/ban-types
export type FixedForwardRef = <T, P = {}>(
  render: (props: Omit<P, 'ref'>, ref: Ref<T>) => JSX.Element
) => (props: P & (RefAttributes<T> | ClassAttributes<T>)) => JSX.Element;

export const fixedForwardRef = forwardRef as FixedForwardRef;

export const useUpdateLayoutEffect = (fn: EffectCallback, deps: DependencyList) => {
  const isFirst = useRef(true);
  useLayoutEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    return fn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export const useUnmount = (callback: EffectCallback) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const handler = () => callbackRef.current?.();
    window.addEventListener('beforeunload', handler);
    return () => {
      handler();
      window.removeEventListener('beforeunload', handler);
    };
  }, []);
};
